import { render, staticRenderFns } from "./LabelsIndex.vue?vue&type=template&id=943d43cc&"
import script from "./LabelsIndex.vue?vue&type=script&lang=js&"
export * from "./LabelsIndex.vue?vue&type=script&lang=js&"
import style0 from "./LabelsIndex.vue?vue&type=style&index=0&id=943d43cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports